import { ModalService } from '@app/plugins/iview-modal-modify/service';
import i18n from '@app/plugins/i18n';
import { TasksService } from '@tasks/services/TasksService';
import ItemForm from '@tasks/components/tasks/create-form.vue';
class TaskModalService extends ModalService {
  constructor() {
    super(TasksService);
  }
  remove(path, item) {
    return this.$removeDeepItem(path, item, {
      content: i18n.t('tasks.task.modal.remove.content', {
        number: `<strong>${item.id}</strong>`
      })
    });
  }
  create(campaign_id) {
    return this.$open({
      title: i18n.t('shared.component.modal.create_task'),
      width: this.size.default,

      render: h =>
        h(ItemForm, {
          props: {
            campaign_id
          },
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new TaskModalService();
export { instance as TaskModalService };
